import { render, staticRenderFns } from "./AllergyIntolerancesView.vue?vue&type=template&id=301db82d&scoped=true&"
import script from "./AllergyIntolerancesView.vue?vue&type=script&lang=ts&"
export * from "./AllergyIntolerancesView.vue?vue&type=script&lang=ts&"
import style0 from "./AllergyIntolerancesView.vue?vue&type=style&index=0&id=301db82d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301db82d",
  null
  
)

export default component.exports